import React from 'react';
import { Col } from 'antd';
import { ButtonsCustom } from './ButtomsCustom';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useResolution886Report } from '@/context/Resolution886Report';
import { useConsolidate } from './hooks';

export function FooterButtons(): JSX.Element {
	const { organization, company } = useApplicationContext();
	const { report, selectedReviewId } = useResolution886Report();

	const { handleConsolidate, consolidateReportLoading, isReportConsolidated } = useConsolidate(
		report,
		company?.id,
		organization?.id,
		selectedReviewId
	);

	async function handleConsolidatePDF(values: {
		file: File | null;
		status: boolean;
		include_fields?: string[];
	}): Promise<void> {
		await handleConsolidate({
			status: values.status,
			include_fields: values.include_fields
		});
	}

	return (
		<Col>
			<ButtonsCustom
				handleConsolidatePDF={handleConsolidatePDF}
				hasCustomModal
				hasConsolidated
				isLoadingPDF={consolidateReportLoading}
				consolidated={isReportConsolidated ?? false}
			/>
		</Col>
	);
}
